export default "__VITE_ASSET__e73b3897__"